import type { Profile } from "@stryker/core/types/accounts";
import { isNullish } from "remeda";

export function getUserRole(user?: Profile | null): "admin" | "engineer" | "user" {
  if (user?.role === "admin") {
    return "admin";
  }
  if (user?.role === "engineer") {
    return "engineer";
  }
  return "user";
}

export function getUserName(user?: Profile | null) {
  return [user?.first_name, user?.last_name].filter(Boolean).join(" ").trim() || "N/A";
}

export function getFloat(text: string): number | undefined {
  if (!text) {
    return undefined;
  }
  const parsed = Number.parseFloat(text);
  return isNaN(parsed) ? undefined : parsed;
}

export const farenheitToCelcius = (f: number | string) => {
  const n = typeof f === "string" ? Number(f) : f;
  return ((n - 32) * 5) / 9;
};

export const celsiusToFahrenheit = (celsius: number | string) => {
  const n = typeof celsius === "string" ? Number(celsius) : celsius;
  return (n * 9) / 5 + 32;
};

export const feetToInches = (feet: number | string) => {
  return Number(feet) * 12;
};

export const inchesToFeet = (inches: number | string) => {
  return Number(inches) / 12;
};

export const convertLength = (value: number | string, fromUnit: string, toUnit: string) => {
  const numValue = typeof value === "string" ? Number.parseFloat(value) : value;
  if (isNaN(numValue)) return 0;

  // Normalize to inches first
  let inInches: number;
  switch (fromUnit.toLowerCase()) {
    case "feet":
      inInches = feetToInches(numValue);
      break;
    default:
      inInches = numValue;
      break;
  }

  // Convert from inches to target unit
  switch (toUnit.toLowerCase()) {
    case "feet":
      return inchesToFeet(inInches);
    default:
      return inInches;
  }
};

export function booleanToYesNo(response?: boolean | null) {
  if (isNullish(response)) {
    return "N/A";
  }
  return response ? "yes" : "no";
}
